import { Check } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const HomeBenefits = () => {
  const t = useT();
  const benefits = [
    t("home.benefit.1"),
    t("home.benefit.2"),
    t("home.benefit.3"),
    t("home.benefit.4"),
    t("home.benefit.5"),
    t("home.benefit.6"),
    t("home.benefit.7"),
  ];

  return (
    <section className="bg-charcoal text-ivory py-24 md:py-32 grain" data-testid="benefits-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12 md:gap-20 items-start">
          <Reveal className="md:col-span-5">
            <p className="text-[11px] tracking-[0.32em] uppercase text-terracotta mb-6">{t("home.benefits.eyebrow")}</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05]">
              {t("home.benefits.title1")} <span className="italic text-terracotta">{t("home.benefits.title2")}</span>.
            </h2>
            <p className="mt-6 text-ivory/65 leading-relaxed font-light">
              {t("home.benefits.lead")}
            </p>
          </Reveal>
          <Reveal delay={0.12} className="md:col-span-7">
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-1">
              {benefits.map((b, i) => (
                <li
                  key={b}
                  className="flex items-center gap-4 py-5 border-b border-ivory/10"
                  data-testid={`benefit-${i}`}
                >
                  <span className="w-8 h-8 rounded-full border border-terracotta/50 flex items-center justify-center text-terracotta">
                    <Check size={14} />
                  </span>
                  <span className="text-[16px] text-ivory/90">{b}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default HomeBenefits;
